export default __webpack_public_path__ + "img/calendar.1a043dff.png";